import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

// Fonction utilitaire exportée pour pouvoir l'utiliser dans la logique de validation des formulaires parent
export const validatePasswordCriteria = (password = '') => {
  return {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
  };
};

// Fonction pour vérifier rapidement si TOUT est valide
export const isPasswordFullyValid = (password) => {
  const criteria = validatePasswordCriteria(password);
  return Object.values(criteria).every(Boolean);
};

const PasswordRequirements = ({ password }) => {
  const criteria = validatePasswordCriteria(password);

  const requirements = [
    { id: 'length', label: 'Au moins 8 caractères', met: criteria.length },
    { id: 'uppercase', label: 'Une lettre majuscule', met: criteria.uppercase },
    { id: 'lowercase', label: 'Une lettre minuscule', met: criteria.lowercase },
    { id: 'number', label: 'Un chiffre', met: criteria.number },
    { id: 'special', label: 'Un caractère spécial', met: criteria.special },
  ];

  return (
    <div style={{
      backgroundColor: 'var(--color-gray-50)',
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid var(--color-gray-200)',
      marginTop: '8px',
      fontSize: '0.85rem'
    }}>
      <p style={{ margin: '0 0 8px 0', fontWeight: '600', color: 'var(--color-gray-700)' }}>
        Votre mot de passe doit contenir :
      </p>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {requirements.map((req) => (
          <li 
            key={req.id} 
            style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '8px',
              color: req.met ? 'var(--color-success)' : 'var(--color-gray-500)',
              transition: 'color 0.3s ease'
            }}
          >
            {req.met ? (
              <CheckCircle2 size={16} strokeWidth={2.5} />
            ) : (
              <XCircle size={16} strokeWidth={2} style={{ opacity: 0.5 }} />
            )}
            <span>{req.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirements;